import { MINIMUM_COPILOT_CHAT_DRAWER_WIDTH } from "../utils/copilotChatDrawerConstants";
import { getCopilotChatDrawerTrueWidth } from "../selectors/getCopilotChatDrawerTrueWidth";
import { getShowBizChatInReadingPane } from "./getShowBizChatInReadingPane";

/**
 * This function determines whether the Copilot Chat Drawer is in an expanded state or not.
 * We are deemed expanded whenever we are greater than the minimum drawer width.
 * @returns true if the Copilot Chat Drawer is in expanded state, false if it is in collapsed state.
 */
export function isCopilotChatDrawerExpanded(targetWindow: Window): boolean {
    return (getCopilotChatDrawerTrueWidth(targetWindow) > MINIMUM_COPILOT_CHAT_DRAWER_WIDTH ||
        getShowBizChatInReadingPane(targetWindow));
}
